import styled, { css } from "styled-components";
import type { WidthProps, DisplayProps } from "styled-system";
import { width, display } from "styled-system";
import Container from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Container";
import * as Flex from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import { theme as toyotaTheme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint, getDirection } from "../../../../../../../../common-deprecated/themes/common";
import * as Tag from "../../../../../../../../common-deprecated/styles/toyota/Tag";
import * as PricePromoIcon from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/price/PricePromoIcon";
import * as MonthlyPrice from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/price/MonthlyPrice";
import * as CashPrice from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/price/CashPrice";
import * as PriceFootNote from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/price/PriceFootNote";
import { WinterToggle } from "../../../common/styles/WinterWheelToggle";
import * as CustomizeCtaContainer from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/CustomizeCtaContainer";
import * as Type from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as ExteriorSpinStyle from "./ExteriorSpinStyle";
import * as Tooltip from "../../../../../../../../common-deprecated/styles/v2/toyota/components/Tooltip";
import { IconWrapper } from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { focusStyle } from "../../../../../../../../common-deprecated/styles/v2/toyota/utilities/Focus";
import { AvailabilityBadges } from "../../../../../../../../common-deprecated/components/aem/toyota/availability-badges/styles/AvailabilityBadgesStyles";

const BG_IMG_WIDTH = 1124;
const BG_IMG_HEIGHT = 416;
const BG_IMG_HEIGHT_XL = 435;

export const Wrapper = styled.div`
    position: relative;
    /* Should be theme.color.grey1 but the backgroundColor from the exterior image is #F0F0F0  */
    margin-top: ${toyotaTheme.space[2]}px;
    background-color: ${toyotaTheme.colors.primaryWhite};
    overflow-x: hidden;
`;

export const Toggle = styled.button<{ isFullscreen?: boolean; hasWinterWheel?: boolean }>`
    display: none;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin-${getDirection("left")}: ${toyotaTheme.space[2]}px;
    font-family: ${toyotaTheme.fonts.regular};
    font-size: 1.3rem;
    text-align: center;
    color: ${toyotaTheme.colors.primaryBlack};
    background-color: ${toyotaTheme.colors.grey1};
    border: 0;
    border-radius: 50%;
    vertical-align: middle;

    @media ${getBreakpoint("up", "lg")} {
        display: flex;
        align-items: center;
    }

    ${focusStyle};
`;

export const ExtraActions = styled(Flex.Col)<{ isFullscreen?: boolean }>`
    display: flex;
    position: absolute;
    top: 0;
    ${getDirection("right")}: 56px; /* 16px (spacing between buttons and toggle) + 40px (width toggle) */
    flex-direction: column;
    align-items: flex-end;
    padding: 0;
    padding-${getDirection("left")}: ${toyotaTheme.space[3]}px;

    ${({ isFullscreen }) =>
        isFullscreen &&
        css`
            top: ${toyotaTheme.space[5]}px;
            ${getDirection(
                "right",
            )}: 80px; /* 24px (spacing from border) + 40px (width Toggle) + 16px (spacing between buttons and toggle)  */
        `};
`;

export const HeaderWrapper = styled.div<{ isFullscreen?: boolean; hasLightColors: boolean }>`
    z-index: 2;

    @media ${getBreakpoint("up", "md")} {
        margin-top: 0;

        /* When on interior step */
        ${({ hasLightColors }) =>
            hasLightColors &&
            css`
                position: absolute;
                left: 0;
                right: 0;
            `}
    }

    ${CashPrice.Text} {
        margin-top: ${toyotaTheme.space[1]}px;
    }

    ${({ isFullscreen }) =>
        isFullscreen &&
        css`
            ${Container} {
                max-width: 1600px;
                padding: ${toyotaTheme.space[3]}px 0 0;
            }
        `};

    ${({ hasLightColors }) =>
        hasLightColors
            ? css`
                  width: 100%;
                  @media ${getBreakpoint("up", "md")} {
                      color: ${toyotaTheme.colors.primaryWhite};

                      ${Type.H1},
                      ${Type.BodyTypeName},
                ${Type.GradeName},
                ${Toggle},
                ${PriceFootNote.Text},
                ${CashPrice.Text},
                ${MonthlyPrice.Text},
                ${Button.Link},
                    a {
                          color: ${toyotaTheme.colors.primaryWhite};
                      }

                      ${Toggle} {
                          color: ${toyotaTheme.colors.primaryBlack};
                          background-color: ${toyotaTheme.colors.primaryWhite};
                      }
                  }
              `
            : css`
                  color: ${toyotaTheme.colors.primaryBlack};
              `};

    ${Type.GradeName} {
        display: block;
        @media ${getBreakpoint("up", "sm")} {
            display: inline-block;
        }
    }

    ${PricePromoIcon.Wrapper} {
        margin: ${toyotaTheme.space[2]}px;
    }
    ${MonthlyPrice.Text} {
        font-size: 1.6rem;
        line-height: 2.4rem;
        color: ${({ hasLightColors }) =>
            !hasLightColors ? toyotaTheme.colors.primaryBlack : toyotaTheme.colors.primaryWhite};
    }
`;

export const ResizeWrapper = styled.div<{ fullscreen: boolean; hasBgImage?: boolean }>`
    position: relative;
    ${({ fullscreen }) =>
        fullscreen &&
        css`
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            padding: 0 40px;
            background-color: ${toyotaTheme.colors.primaryWhite};
            z-index: ${toyotaTheme.zIndex.overlay};
        `};

    ${({ hasBgImage, fullscreen }) =>
        hasBgImage &&
        !fullscreen &&
        css`
            height: 350px;
            @media ${getBreakpoint("up", "sm")} {
                height: ${BG_IMG_HEIGHT}px;
            }
            @media ${getBreakpoint("up", "md")} {
                height: 460px;
            }
            @media ${getBreakpoint("up", "lg")} {
                height: 350px;
            }
            @media ${getBreakpoint("up", "xl")} {
                height: 440px;
            }
            @media (min-width: 2500px) {
                height: ${BG_IMG_HEIGHT_XL}px;
            }
        `};
`;

export const ExteriorSpinWrapper = styled(Flex.Col)<{
    hidden?: boolean;
    isFullscreen?: boolean;
    hasBgImage?: boolean;
}>`
    display: flex;
    order: 3;
    width: 100%;
    z-index: 1;

    @media ${getBreakpoint("up", "lg")} {
        position: absolute;
        top: 0;
        left: 50%;
        order: unset;
        max-width: 850px;
        transform: translateX(-50%);
    }

    ${({ isFullscreen, hasBgImage }) =>
        isFullscreen &&
        css`
            @media ${getBreakpoint("up", "lg")} {
                position: ${hasBgImage ? "fixed" : "absolute"};
                top: ${hasBgImage ? 0 : "50%"};
                left: 0;
                order: 3;
                width: 100%;
                max-width: none;
                transform: none;

                ${hasBgImage &&
                css`
                    ${ExteriorSpinStyle.SpinImage} {
                        max-width: none;
                    }
                    ${ExteriorSpinStyle.SpinPlayer} {
                        max-width: none;
                        & > button {
                            top: 25vh;

                            @media (min-width: 2500px) {
                                top: 50vh;
                            }
                        }
                    }
                `};
            }
        `};

    ${({ hidden }) =>
        hidden &&
        css`
            display: none;
        `};

    ${({ hasBgImage, isFullscreen }) =>
        hasBgImage &&
        !isFullscreen &&
        css`
            width: 100%;
            @media ${getBreakpoint("up", "lg")} {
                top: -${toyotaTheme.space[3]}px;
                left: 0;
                max-width: none;
                height: 100%;
                transform: none;
            }
            @media ${getBreakpoint("up", "xl")} {
                width: ${BG_IMG_WIDTH}px;
                height: ${BG_IMG_HEIGHT}px;
            }

            ${ExteriorSpinStyle.SpinImage} {
                @media ${getBreakpoint("up", "sm")} {
                    max-width: none;
                }
            }

            ${ExteriorSpinStyle.Wrapper},
            ${ExteriorSpinStyle.SpinPlayer} {
                @media ${getBreakpoint("up", "lg")} {
                    padding-top: 0;
                }
            }
        `};
`;

export const InteriorGalleryWrapper = styled(Container)<{ isFullscreen?: boolean }>`
    position: relative;
    padding-left: 0;
    padding-right: 0;

    ${({ isFullscreen }) =>
        isFullscreen &&
        css`
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            max-width: 100% !important;
            padding: 0;
        `};
`;

export const DisclaimerReference = styled.div`
    position: absolute;
    bottom: 0;
    right: 10px;
    font-size: 4rem;
    text-shadow: 2px 2px 2px ${({ theme }) => theme.color.grey5};
    color: ${toyotaTheme.colors.primaryWhite};

    @media ${getBreakpoint("down", "xl")} {
        right: ${toyotaTheme.space[3]}px;
    }
`;

export const Header = styled(Flex.Row)`
    position: relative;
    justify-content: space-between;
    ${Tag.Eco} {
        margin-top: ${toyotaTheme.space[2]}px;
        @media ${getBreakpoint("down", "md")} {
            position: absolute;
            top: 0;
            ${getDirection("right")}: ${toyotaTheme.space[3]}px;
        }
    }
`;

export const Toolbar = styled.div<WidthProps>`
    position: relative;
    z-index: 5; /* z-index should be higher then the car-hero image, and lower then mobile footer */
    ${width};

    ${CustomizeCtaContainer.Wrapper} {
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        margin: ${toyotaTheme.space[4]}px 0;
    }

    ${WinterToggle} {
        display: none;

        @media ${getBreakpoint("up", "lg")} {
            display: block;
            position: absolute;
            right: 0;
        }

        @media (orientation: landscape) and ${getBreakpoint("only", "md")} {
            position: absolute;
            right: 0;
        }
    }

    @media ${getBreakpoint("down", "md")} {
        ${CustomizeCtaContainer.Wrapper} {
            max-width: 100%;
            & > a {
                max-width: unset;
            }
        }
    }

    @media ${getBreakpoint("up", "lg")} {
        ${CustomizeCtaContainer.Wrapper} {
            display: none;
        }
    }
`;

export const Center = styled(Flex.Col)<{ hasLightColor?: boolean; hasAvailabilityBadges?: boolean }>`
    ${({ hasLightColor, hasAvailabilityBadges }) =>
        hasLightColor &&
        hasAvailabilityBadges &&
        css`
            @media ${getBreakpoint("up", "lg")} {
                width: 33.33333%;
            }
        `};
`;

export const LeftCorner = styled(Flex.Col)<{
    hasLightColors?: boolean;
    isFullscreen?: boolean;
    hasAvailabilityBadges?: boolean;
}>`
    flex-grow: 1;
    padding: 0;
    padding-${getDirection("left")}: ${toyotaTheme.space[3]}px;
    text-align: start;
    z-index: 10;

    ${Tag.Eco} {
        position: relative;
    }

    ${CashPrice.Text} {
        font-size: 1.6rem;
    }

    ${Button.Link} {
        text-align: start;
    }

    ${Type.SmallText} {
        ${({ hasLightColors }) =>
            hasLightColors &&
            css`
                color: ${toyotaTheme.colors.primaryWhite};
            `};
    }

    ${AvailabilityBadges} {
        margin-top: ${toyotaTheme.space[2]}px;
    }

    @media ${getBreakpoint("up", "md")} {
        flex-grow: 0;
        padding: ${toyotaTheme.space[3]}px ${toyotaTheme.space[3]}px 0;
        ${({ hasLightColors }) =>
            hasLightColors &&
            css`
                padding-${getDirection("left")}: ${toyotaTheme.space[3]}px;
                text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);

                ${CashPrice.SpanText} {
                    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
                    color: ${toyotaTheme.colors.primaryWhite};
                }
                ${Tooltip.TooltipButton} .dxp-icon {
                    color: ${toyotaTheme.colors.primaryWhite};
                }
            `};
    }

    @media ${getBreakpoint("down", "lg")} {
        ${Tag.Eco} {
            display: none;
        }
    }

    ${({ hasLightColors, hasAvailabilityBadges, isFullscreen }) =>
        hasLightColors &&
        hasAvailabilityBadges &&
        css`
            @media ${getBreakpoint("up", "md")} {
                display: flex;
                column-gap: ${toyotaTheme.space[3]}px;
                flex-basis: 65%;

                ${AvailabilityBadges} {
                    margin-top: ${isFullscreen ? "0px" : `${toyotaTheme.space[3]}px`};
                }
            }
            @media ${getBreakpoint("up", "lg")} {
                flex-basis: 45%;
            }
        `};
`;

export const RightCorner = styled(Flex.Col)<{
    isFullscreen?: boolean;
    hasLightColor?: boolean;
    hasAvailabilityBadges?: boolean;
}>`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    order: 2;
    padding-top: ${toyotaTheme.space[5]}px;
    z-index: 11;

    ${CustomizeCtaContainer.Wrapper} {
        display: none;
        @media ${getBreakpoint("up", "lg")} {
            display: flex;
        }
    }

    @media ${getBreakpoint("down", "md")} {
        flex-shrink: 1;
        width: auto;
    }

    @media ${getBreakpoint("up", "lg")} {
        order: 3;
        padding-top: ${toyotaTheme.space[3]}px;

        ${WinterToggle}, ${Tag.Eco} {
            display: none;
        }
    }

    ${({ isFullscreen }) =>
        isFullscreen &&
        css`
            ${CustomizeCtaContainer.Wrapper} {
                display: none;
            }
        `};

    ${({ hasLightColor, hasAvailabilityBadges }) =>
        hasLightColor &&
        css`
            svg g {
                stroke: ${toyotaTheme.colors.primaryWhite};
            }

            ${hasAvailabilityBadges &&
            css`
                @media ${getBreakpoint("up", "md")} {
                    flex-basis: 35%;
                }
                @media ${getBreakpoint("up", "lg")} {
                    flex-basis: 16.6667%;
                }
            `};
        `};
`;

export const RightCornerTop = styled.div`
    display: flex;
    justify-content: flex-end;
    max-height: 60px;
`;

export const RightCornerBottom = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-top: ${toyotaTheme.space[3]}px;
`;

export const FinanceToggle = styled.a`
    display: inline-block;
    margin-top: 16px;
    color: ${({ theme }) => theme.color.grey5};
`;

export const ExteriorSpin3DToggle = styled.button<DisplayProps | { disabled: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 40px;
    margin-top: ${toyotaTheme.space[2]}px;
    padding: ${toyotaTheme.space[1]}px ${toyotaTheme.space[2]}px;
    font-family: ${toyotaTheme.fonts.regular};
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: ${toyotaTheme.colors.primaryBlack};
    background-color: ${toyotaTheme.colors.grey1};
    border: 0;
    border-radius: 30px;
    transition: all 0.2s ease-in-out;
    cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
    ${display};
    
    ${IconWrapper} {
        margin-${getDirection("left")}: ${toyotaTheme.space[1]}px;
    }

    @media ${getBreakpoint("up", "lg")} {
        margin-top: 0;
    }
`;

export const GrLogo = styled.div`
    position: relative;
    width: 80px;

    @media ${getBreakpoint("up", "md")} {
        margin: 0 ${toyotaTheme.space[3]}px;
    }
`;
